<template>
    <DsModal
        class="configuration-modal"
        :is-open="isOpen"
        :show-close="showClose"
        :size="size"
        :title="title"
        :funnel-id="funnelId"
        @close="close"
    >
        <template #header>
            <DsFilledButton @click="close">
                {{ $options.MESSAGE_CONSTANTS.actionButtonLabel }}
            </DsFilledButton>
        </template>

        <template #default>
            <slot name="configurationParameters" />

            <div class="configuration-tip">
                <div class="configuration-tip-icon">
                    <DsIcon name="info-circle" />
                </div>

                <div class="configuration-tip-text">
                    {{ configurationTipText }}
                    <div>
                        <DsFilledButton
                            v-if="configurationTipLink"
                            class="configuration-tip-button"
                            as="a"
                            :href="configurationTipLink"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ $options.MESSAGE_CONSTANTS.configurationTipButtonLabel }}
                            </div>
                        </DsFilledButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>

export const MESSAGE_CONSTANTS = {
    actionButtonLabel: 'Done',
    configurationTipButtonLabel: 'Learn more',
};

export default {
    MESSAGE_CONSTANTS,

    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        configurationTipLink: {
            type: String,
            required: true,
        },
        configurationTipText: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'med',
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },
    emits: ['close-configuration-modal'],
    methods: {
        close() {
            this.$emit('close-configuration-modal');
        },
    },
};
</script>

<style lang="scss" scoped>
.configuration-tip {
    display: flex;
    padding: 12px;
    border-radius: 8px;
    flex-wrap: wrap;
    justify-items: left;
    background-color: $color-blue-050;
    margin: 20px;
}

.configuration-tip-icon {
    flex: 6%;
    color: $color-blue-300;
}

.configuration-tip-text {
    margin-top: 2px;
    flex: 94%;
    color: $color-ink-900;
}

.configuration-tip-button {
    height: 32px;
    padding: 8px 12px 8px 8px;
    border-radius: 8px;
    color: $color-ink-900;
    background-color: $color-ink-100;
}
</style>
